// Single source of truth for the visitor's cookie consent.
// Categories follow the client's 15 Oct "Your privacy choices" design. Essential cookies (Stripe,
// Google Pay at checkout) need no consent. The FirstPromoter affiliate cookie is the only
// marketing tool today; performance and functionality have no tools yet, but any added later
// must check hasConsent() before loading.
// Bump CONSENT_VERSION when the cookie policy / categories change so visitors are asked again.
export const CONSENT_KEY = 'cookiePrefs';
export const CONSENT_VERSION = 2;
export const CONSENT_EVENT = 'cookieConsentChanged';

export const OPTIONAL_CATEGORIES = ['performance', 'functionality', 'marketing'];

const buildPrefs = (value) => ({ performance: value, functionality: value, marketing: value });
export const ALL_REJECTED = buildPrefs(false);
export const ALL_ACCEPTED = buildPrefs(true);

const FPR_SCRIPT_SRC = 'https://cdn.firstpromoter.com/fpr.js';
const FPR_COOKIES = ['_fprom_tid', '_fprom_ref'];

// Returns the stored consent, or null when the visitor has not made a (current) choice yet.
export const getConsent = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (!saved || saved.version !== CONSENT_VERSION) return null;
    return saved;
  } catch (e) {
    return null;
  }
};

export const hasConsent = (category) => {
  if (category === 'essential') return true;
  return Boolean(getConsent()?.[category]);
};

// fpr.js is NOT in index.html; only the queueing stub is. The real script loads after marketing
// consent and then replays the queued init/click/track calls.
export const loadAffiliateScript = () => {
  if (document.querySelector(`script[src="${FPR_SCRIPT_SRC}"]`)) return;
  const script = document.createElement('script');
  script.src = FPR_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
};

const deleteAffiliateCookies = () => {
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.replace(/^www\./, '')}`];
  FPR_COOKIES.forEach((name) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
    });
  });
};

export const saveConsent = (prefs) => {
  const hadMarketing = hasConsent('marketing');
  const record = {
    essential: true,
    performance: Boolean(prefs.performance),
    functionality: Boolean(prefs.functionality),
    marketing: Boolean(prefs.marketing),
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(record));
  } catch (e) {
    // Storage blocked: the choice still applies for this page view.
  }

  if (record.marketing) {
    loadAffiliateScript();
  } else {
    deleteAffiliateCookies();
    // fpr.js keeps running once loaded, so reload to stop it after consent is withdrawn.
    if (hadMarketing) window.location.reload();
  }

  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: record }));
  return record;
};
